import themeConstants from '@/components/theme/theme-constants';

export const ANCHOR_MARGIN_TOP = 18;

export function scrollToAnchor(anchorName: string, options?: ScrollToOptions) {
  const anchor = document.querySelector(`[data-anchor="${CSS.escape(anchorName)}"]`);
  if (!anchor) return;

  const rect = anchor.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  const productHeaderHeight = convertStyleToNumber(themeConstants.layout.productHeaderHeight);
  const headerHeight = convertStyleToNumber(themeConstants.layout.headerHeight);
  const offset = productHeaderHeight + headerHeight + ANCHOR_MARGIN_TOP;

  const targetY = rect.top + scrollTop - offset;

  window.scrollTo({
    top: targetY,
    ...options,
  });
}

const convertStyleToNumber = (style: string) => {
  const number = parseInt(style.replace('px', ''), 10);
  return isNaN(number) ? 0 : number;
};
